<template>
  <LoaderComponent :is-visible="this.$store.state.isLoading"></LoaderComponent>
  <SnackbarComponent v-if="$store.state.isSnackbarEnabled" :isSuccess="$store.state.snackBarStatus" :message="$store.state.snackBarMessage"></SnackbarComponent>
  <router-view />
</template>

<script>
import LoaderComponent from './components/semantics/LoaderComponent.vue'
import SnackbarComponent from './components/semantics/SnackbarComponent.vue';

export default {
  name: 'App',
  components: {
    LoaderComponent,
    SnackbarComponent

  },
  beforeMount() {
    this.$store.dispatch("initializeInterceptor");
  }
}
</script>




<style>
body {
  padding: 0px;
  margin: 0px;
}

.font-weight-550 {
  font-weight: 550;
}

.btn-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.f-15 {
  font-size: 20px;
  margin-top: 10px;
  font-weight: 600;
}

.f-18 {
  font-size: 18px;
}

.f-13 {
  font-size: 13px;
}

.Black {
  background: #333;
  color: white;
}

.content {
  min-height: 87vh;
}
</style>



